import { useMemo } from 'react'

import { CurrenciesFilterDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { createCurrencyFilter, dateFilter, dueDateFilter, statusFilter } from './filters'

export const usePaymentsFilters = () => {
  const { data: currenciesData } = useQuery(CurrenciesFilterDataDocument)

  const currencyOptions = useMemo(() => {
    const currencies = currenciesData?.apiCore?.currencies || []
    return currencies.map((currency) => ({
      label: `${currency.isoCode} - ${currency.name}`,
      value: currency.isoCode,
    }))
  }, [currenciesData])

  return useMemo(
    () => ({
      status: statusFilter(),
      date: dateFilter(),
      dueDate: dueDateFilter(),
      currency: createCurrencyFilter(currencyOptions),
    }),
    [currencyOptions]
  )
}
